export default "__VITE_ASSET__O8GuUX4e__"